export default {"src":"/_next/static/media/fire.20d5183d.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};